import instance from "./instance";

import authModule from "./auth"
import userModule from "./user"
import scheduleModule from "./schedule"
import contractModule from "./contract"
import serviceModule from "./service"
import settingsModule from "./settings"
import shopModule from "./shop"
import paymentModule from "./payment";
import documentsModule from "./documents";

export default {
    auth: authModule(instance),
    user: userModule(instance),
    schedule: scheduleModule(instance),
    contract: contractModule(instance),
    service: serviceModule(instance),
    settings: settingsModule(instance),
    shop: shopModule(instance),
    payment: paymentModule(instance),
    documents: documentsModule(instance),
}